import { deleteWebhookConfigDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteWebhookConfigCallable = getCallable(
  deleteWebhookConfigDefinition,
);
